import { render, staticRenderFns } from "./GroupTabs.vue?vue&type=template&id=228a2db0&scoped=true&"
import script from "./GroupTabs.vue?vue&type=script&lang=js&"
export * from "./GroupTabs.vue?vue&type=script&lang=js&"
import style0 from "./GroupTabs.vue?vue&type=style&index=0&id=228a2db0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a2db0",
  null
  
)

export default component.exports